<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="col-md-12" v-else>
      <b-card class="heightCardHeader">
        <b-form-group
          label="Compartilhe conosco o motivo pelo qual você deseja se desligar da Cooperativa Unicampo"
          class="col-md-7 mb-3"
        >
          <multiselect
            v-model="dados.motivo"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionMotivo"
            label="ds_motivo_desligamento"
            track-by="sq_motivo_desligamento"
            :allow-empty="false"
            :max-height="200"
          />
        </b-form-group>
        <b-form-group
          class="col-md-12 mb-3"
          label="Sinta-se a vontade para deixar suas considerações"
        >
          <b-form-textarea
            v-model="dados.justificativa"
            type="text"
            autocomplete="off"
            maxlength="400"
            trim
          ></b-form-textarea>
          <div class="text-center">
            <p
              v-if="dados.justificativa"
              class="badge position-absolute"
              :class="{
                'bg-success': dados.justificativa.length !== 400,
                'bg-danger': dados.justificativa.length === 400,
              }"
            >
              {{ dados.justificativa.length }} / 400
            </p>
          </div>
        </b-form-group>
        <div class="row">
          <div class="mt-1 d-flex justify-content-between">
            <router-link
              :to="'/cooperado/contaCapital/desligamento/confirmacaoDesligamento'"
            >
              <b-button size="md"> voltar </b-button>
            </router-link>
            <div class="mt-1 text-end">
              <b-button
                class="mt-1 me-1 font-size-13"
                variant="primary"
                @click="enviarSolicitacao()"
                :disabled="loadingSolicitarDesligamento"
              >
                Enviar Solicitação
                <b-spinner
                  class="ms-2"
                  small
                  variant="success"
                  v-if="loadingSolicitarDesligamento"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
    
<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
export default {
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Justificativa de Desligamento",
      items: [
        {
          text: "Conta Capital",
          active: false,
          href: "/cooperado/contaCapital",
        },
        {
          text: "Confirmar Dados de Desligamento",
          active: false,
          href: "/cooperado/contaCapital/desligamento/confirmacaoDesligamento",
        },
        {
          text: "Justificativa de Desligamento",
          active: true,
        },
        {
          text: this.$store.state.nrMatricula,
          active: true,
        },
      ],
      loading: false,
      dados: {
        motivo: "",
        justificativa: "",
      },
      optionMotivo: [],
      loadingSolicitarDesligamento: false,
    };
  },
  async created() {
    this.$tools.fecharMenu();
    await this.preencherLookUp();
  },

  methods: {
    async preencherLookUp() {
      try {
        const respMotivo = await this.$http.get(
          "api/desligamento/buscarMotivos"
        );
        this.optionMotivo = respMotivo.data;
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loading = false;
      }
    },

    async verificarPendenciaAssinatura() {
      try {
        const response = await this.$http.get("api/assinaturaEletronica/verificarPendenciaAssinaturaEletronica");

        // Verifica se existe documento a ser assinado, se não existe, ele continua o fluxo normal, se existe, ele redireciona para a tela de assinatura
        if (response.data.length > 0) {
          if (response.data[0].TIPOPENDENCIA === "S" && response.data[0].SQUPLOADPENDENCIA !== null) {
            this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", false);
            this.$router.push("/assinaturaEletronica");
          } else {
            this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
            this.$router.push("/");
          }
        }
      } catch (error) {
        this.$tools.alerta(error, "error");
      }
    },

    enviarSolicitacao() {
      this.loadingSolicitarDesligamento = true;
      const item = {
        nr_matricula: this.$store.state.nrMatricula,
        sq_motivo_desligamento: this.dados.motivo.sq_motivo_desligamento
          ? this.dados.motivo.sq_motivo_desligamento
          : null,
        justificativa: this.dados.justificativa
          ? this.dados.justificativa
          : null,
      };

      try {
        this.$http.post("api/desligamento/solicitaDesligamento", item);
        this.$http
          .get("api/desligamento/geraDocumentoDesligamento")
          .then(() => {
            this.$tools.alerta("Solicitação enviada com sucesso", "success");
            this.$router.push("/cooperado/contaCapital");
          })
          .catch(() => {
            this.$tools.alerta("Não foi possível salvar", "error");
          });
        setTimeout(async () => {
          await this.verificarPendenciaAssinatura();
        }, 6000);
      } catch (error) {
        this.$tools.alerta(error, "error");
      }
    },
  },
};
</script>